
import data from '../assets/data/substances.json'
export const state = () => ({ data })
